import { Box } from '@mui/material';
import { FormDialogContext, FormDialogContextType } from '@react-admin/ra-form-layout';
import { ReactNode, useContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Button, Toolbar } from 'react-admin';

export const DialogToolbar = (props: {
  button: ReactNode;
  hideCancel?: boolean;
  formDialogContext?: typeof FormDialogContext;
}) => {
  const dialogContext = useContext(
    props.formDialogContext || FormDialogContext,
  ) as unknown as FormDialogContextType | null;

  return (
    <Toolbar
      disableGutters
      sx={{
        position: 'sticky',
        background: 'white',
        zIndex: 10,
        bottom: 0,
        margin: 0,
        borderTop: '#E0E0E0',
        borderTopStyle: 'solid',
        borderWidth: '1px',
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          gap: '10px',
          marginRight: '10px',
        }}>
        {dialogContext && !props.hideCancel && (
          <Button
            sx={{ color: 'black' }}
            onClick={() => dialogContext.close()}
            label="ra.action.cancel"
            data-testid="BoExternalDialogToolbar_CancelButton"
          />
        )}
        {props.button}
      </Box>
    </Toolbar>
  );
};
